import React from 'react';
import Login from '../Login';

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
	const [isAuthed, setIsAuthed] = React.useState(false);
	const [userInfo, setUserInfo] = React.useState({});
	const value = { isAuthed, setIsAuthed, userInfo, setUserInfo };
	return <AuthContext.Provider value={value}>{isAuthed ? children : <Login />}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
